import dashboardReducer from './reducers';
export { default as dashboardOperations } from './operations';
export { default as dashboardTypes } from './types';
export default dashboardReducer;
